import { Component } from '@angular/core';
@Component({
	templateUrl: './rh.component.html',
})

export class RHComponent{
}